import React, { useState, useEffect } from 'react';
import { SolicitationView } from '../../../models/SolicitationView';
import SolicitationService from "../../../services/SolicitationService/SolicitationService";
import LcIcon from '../LcIcon';
import LcIconLink from '../LcIconLink';
import "./index.css";
import { useSelector } from 'react-redux';
import { UserState } from '../../../store/reducers/userReducer';
import { RootState } from '../../../store/index';

interface Props {
    selectedRow: any
    alterLoadingSaveSubject: Function
    loadingSaveSubject: boolean
    alterSelectedRow: Function
}

const EditSubjectModal: React.FC<Props> = (props) => {
    const solicitationService = new SolicitationService(props);

    const [editSubject, setEditSubject] = useState<boolean>(false);
    const [editSubjectValue, setEditSubjectValue] = useState<string>("");
    const [workIcon, setWorkIcon] = useState<string>("");
    const user = useSelector<RootState, UserState>(state => state.user);

    useEffect(() => {
        setEditSubjectValue((props.selectedRow) ? props.selectedRow.subject : "");

        if (props.selectedRow == undefined) {
            setEditSubject(false);
            setEditSubjectValue("");
        }
    }, [props.selectedRow])

    const handleSubjectChange = (e: any) => {
        setEditSubjectValue(e.target.value);
    }

    const saveSubject = async () => {
        props.alterLoadingSaveSubject(true);

        try {
            let solicitationSave: SolicitationView = props.selectedRow as SolicitationView;
            solicitationSave.subject = editSubjectValue;

            const solicitationUserUpdate = {
                updatedUser: Number(user.id),
                updatedSolicitation: solicitationSave
            }
            var solicitationResponse = await solicitationService.updateSubject(solicitationUserUpdate);
            props.alterSelectedRow(solicitationResponse.data);
        }
        catch (error) {
            console.warn(error);
        }

        setEditSubject(false);
        setEditSubjectValue("");
        props.alterLoadingSaveSubject(false);
    }

    useEffect(() => {
        if (props.selectedRow) {
            // const workStatus_ = solicitationService.workStatus.find(x => x && x.id === selectedRow.workStatus);
            // setWorkIcon((workStatus_) ? workStatus_.icon : "");
            setWorkIcon(props.selectedRow.statusIcon);
        }
    }, [props.selectedRow])

    return (
        <>
            {
                props.loadingSaveSubject
                    ? <></>
                    : <div className={"divOrderTitleEditSubjectModal"} >
                        {
                            editSubject
                                ? <div className={"divOrderEditSubjectModal"}>
                                    <input
                                        className={"titleEditSubjectModal"}
                                        value={editSubjectValue}
                                        onChange={handleSubjectChange}
                                        autoComplete="off"
                                        autoFocus
                                    />
                                    <div>
                                        <button
                                            type="button"
                                            className={"lc-button small bg-info"}
                                            onClick={() => saveSubject()}
                                            style={{ marginRight: "10px" }}
                                        > Salvar </button>
                                        <button
                                            type="button"
                                            className={"lc-button small bg-info"}
                                            onClick={() => setEditSubject(false)}
                                        > Fechar </button>
                                    </div>
                                </div>
                                : <>
                                    {
                                        props.selectedRow &&
                                        <>
                                            <LcIcon icon={workIcon} color={"#141B4D"} />
                                            <span style={{ marginRight: "10px", width: "95%" }}>
                                                <b>{props.selectedRow.id}</b>
                                                {": "}
                                                <span
                                                    style={{
                                                        overflowWrap: 'break-word',
                                                        width: '100%'
                                                    }}>
                                                    {props.selectedRow.subject}
                                                </span>
                                            </span>
                                            {
                                                props.selectedRow.idStatus !== 8 && props.selectedRow.idStatus !== 6 &&
                                                <LcIconLink icon={"ppi ppi-pencil"} tooltip="Editar" onClick={() => { setEditSubjectValue(props.selectedRow.subject); setEditSubject(true); }} />
                                            }
                                        </>
                                    }
                                </>
                        }
                    </div>
            }
        </>
    );
};

export default EditSubjectModal;